import React, { useState } from "react";
import { Building2, LineChart, Bitcoin, Trophy, Zap, Users, Radar } from "lucide-react";
import FloorCommandRoom from "./floor/FloorCommandRoom";
import NexusTradingHouse from "./NexusTradingHouse";
import NexusTrades from "./NexusTrades";
import NexusCrypto from "./NexusCrypto";
import NexusPaper from "./NexusPaper";
import NexusExecution from "./NexusExecution";
import NexusTeam from "./NexusTeam";

const SUBS = [
  { id: "floor", label: "Floor", icon: Radar },
  { id: "house", label: "The House", icon: Building2 },
  { id: "execution", label: "Live Execution", icon: Zap },
  { id: "record", label: "Track Record", icon: Trophy },
  { id: "team", label: "Team", icon: Users },
  { id: "stocks", label: "Stocks", icon: LineChart },
  { id: "crypto", label: "Crypto", icon: Bitcoin },
];

export default function NexusTradingHub({ session }) {
  const [sub, setSub] = useState("floor");
  return (
    <div className="h-full flex flex-col bg-[#030712]" data-testid="trading-hub">
      <div className="flex items-center gap-1.5 px-3 py-2 border-b border-[#FFD70022] overflow-x-auto shrink-0">
        {SUBS.map((s) => {
          const Icon = s.icon;
          return (
            <button key={s.id} onClick={() => setSub(s.id)} data-testid={`hub-sub-${s.id}`}
              className={`px-3 py-1.5 rounded-lg text-xs font-bold flex items-center gap-1.5 whitespace-nowrap transition-colors
                ${sub === s.id ? "bg-[#FFD700] text-black" : "text-cyan-200/60 hover:bg-[#ffffff08]"}`}>
              <Icon className="w-3.5 h-3.5" />{s.label}
            </button>
          );
        })}
      </div>
      <div className="flex-1 min-h-0">
        {sub === "floor" ? <FloorCommandRoom session={session} />
          : sub === "house" ? <NexusTradingHouse session={session} />
          : sub === "execution" ? <NexusExecution session={session} />
          : sub === "record" ? <NexusPaper session={session} />
          : sub === "team" ? <NexusTeam session={session} />
          : sub === "stocks" ? <NexusTrades session={session} />
          : <NexusCrypto session={session} />}
      </div>
    </div>
  );
}
